import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const EmailIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 80 67" {...props}>
      <path
        fill={fill}
        d="M0.000111111111,19.2156 L26.179,33.63735 L0.751222222,60.1782833 C0.271222222,58.93655 0.000111111111,57.5876167 0.000111111111,56.1716833 L0.000111111111,19.2156 Z M53.876,33.6951933 L80.0004444,19.2399433 L80.0004444,56.17146 C80.0004444,57.5873933 79.7293333,58.9363267 79.2493333,60.17806 L53.876,33.6951933 Z M79.9756667,10.3308417 L40.1023333,32.3939417 L0.0245555556,10.3152083 C0.286777778,4.58335833 4.86122222,0.000558333333 10.4634444,0.000558333333 L69.5367778,0.000558333333 C75.1445556,0.000558333333 79.7212222,4.591175 79.9756667,10.3308417 Z M46.8197778,37.5991717 L73.9886667,65.9569217 C72.6353333,66.619105 71.1297778,66.9998883 69.5364444,66.9998883 L10.4631111,66.9998883 C8.86977778,66.9998883 7.36422222,66.6179883 6.01088889,65.9569217 L33.2464444,37.5299383 L38.2375556,40.2802883 C38.8197778,40.6007717 39.4631111,40.7615717 40.1064444,40.7615717 C40.752,40.7615717 41.3986667,40.599655 41.982,40.2758217 L46.8197778,37.5991717 Z"
      />
    </Icon>
  );
};

EmailIcon.propTypes = {
  fill: PropTypes.string,
};

export default EmailIcon;
